export default [

  {
    path: '/gz-live/index',
    name: 'Index',
    component: () => import('@/views/gz-live/index'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2021高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live/liveList',
    name: 'LiveList',
    component: () => import('@/views/gz-live/liveList'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2021高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live/live/:id',
    name: 'Live',
    component: () => import('@/views/gz-live/live'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2021高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
  {
    path: '/gz-live/myLive',
    name: 'MyLive',
    component: () => import('@/views/gz-live/myLive'),
    meta: {
      title: '高招咨询会-高考直通车',
      shareimg: 'https://img.gaokaozhitongche.com/static/shike.png',
      sharedsc: '为帮助2021高考生和家长精准把握高校招生及培养政策，高考直通车举办“高招咨询会”活动，邀请高校招办老师，通过直播形式，与考生及家长进行即时交流并答疑解惑！'
    }
  },
]
